export default __webpack_public_path__ + "static/media/dark-menu.501f0256.svg";